import React, { useEffect, useState } from "react";
import Grid from "@mui/material/Grid";
import MenuItem from "@mui/material/MenuItem";
import axios from "api/axios";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";
import MDBox from "components/MDBox";
import PageShell, { SectionCard } from "components/patch/PageShell";
import SimpleTable from "components/patch/SimpleTable";

export default function UserManagement() {
  const [rows, setRows] = useState([]);
  const [form, setForm] = useState({ name: "", email: "", password: "ChangeMe123!" });

  const load = async () => {
    const res = await axios.get("/admin/users");
    setRows(res.data?.data || res.data || []);
  };

  useEffect(() => {
    load();
  }, []);

  const createUser = async () => {
    await axios.post("/admin/users", form);
    setForm({ name: "", email: "", password: "ChangeMe123!" });
    await load();
  };

  return (
    <PageShell title="Users" subtitle="Create, review and manage application users.">
      <Grid container spacing={3}>
        <Grid item xs={12} lg={4}>
          <SectionCard title="Create User">
            <MDBox display="flex" flexDirection="column" gap={2}>
              <MDInput
                label="Full name"
                value={form.name}
                onChange={(e) => setForm({ ...form, name: e.target.value })}
              />
              <MDInput
                label="Email"
                value={form.email}
                onChange={(e) => setForm({ ...form, email: e.target.value })}
              />
              <MDInput
                label="Temporary password"
                value={form.password}
                onChange={(e) => setForm({ ...form, password: e.target.value })}
              />
              <MDButton variant="gradient" color="info" onClick={createUser}>
                Create
              </MDButton>
            </MDBox>
          </SectionCard>
        </Grid>
        <Grid item xs={12} lg={8}>
          <SectionCard title="User Register">
            <SimpleTable
              columns={[
                { key: "id", label: "ID" },
                { key: "name", label: "Name" },
                { key: "email", label: "Email" },
                { key: "status", label: "Status" },
              ]}
              rows={rows}
            />
          </SectionCard>
        </Grid>
      </Grid>
    </PageShell>
  );
}
